import { selectorFamily } from "recoil";
import { stringify } from "query-string";

export const placePhotosState = selectorFamily({
  key: "placePhotosState",
  get:
    ({ fsq_id, limit = 50, ...query }) =>
    async () => {
      const options = {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: process.env.REACT_APP_FSQ_KEY,
        },
      };
      try {
        const response = await fetch(
          `https://api.foursquare.com/v3/places/${fsq_id}/photos?${stringify({
            ...query,
            limit,
          })}`,
          options
        );
        if (response.status >= 300) {
          return null;
        }
        const data = await response.json();
        return data.map((d) => ({ ...d, date: new Date(d.created_at) }));
      } catch (error) {
        console.log(error);
        return error;
      }
    },
});
